<template>
  <MainLayout>
    <template #seo>
      <SeoPageContent />
    </template>

    <SeoTemplate
      :seo-title="get_seoPage.title"
      :seo-description="get_seoPage.description"
      twitter-img-url="/img/seo/home/main-page_1200_1200.jpg"
      og-img-url="/img/seo/home/main-page_1200_630.jpg"
    />
  </MainLayout>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import SeoPageContent from '@/components/shared/SeoPageContent'
import MainLayout from '@/components/Home/MainLayout'
import SeoTemplate from '@/components/shared/SeoTemplate'
import { jsonldCasino } from '@/util/helpers/jsonldHelper.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MainPage',
  components: {
    LazyHydrate,
    SeoPageContent,
    MainLayout,
    SeoTemplate,
  },
  layout: 'main',
  fetch() {
    this.fetch_seoPage(this.$route.path)
  },
  computed: {
    ...mapGetters('seo', ['get_seoPage']),
  },
  jsonld() {
    return jsonldCasino(this.$config.cloudUrl, this.$t('microDataMainPage'))
  },
  methods: {
    ...mapActions('seo', ['fetch_seoPage']),
  },
}
</script>
